import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const GoldAccent = () => (
  <div className="flex justify-center mt-3 mb-8">
    <div className="h-[3px] w-16 bg-[#D4A017] rounded-full" />
  </div>
);

const InstitutionalPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section — Navy */}
      <section className="relative pt-32 pb-24 px-4 sm:px-6 lg:px-8 bg-[#1B2A4A]">
        <div className="absolute inset-0 opacity-5 pointer-events-none"
          style={{ backgroundImage: 'repeating-linear-gradient(0deg, #D4A017 0px, #D4A017 1px, transparent 1px, transparent 40px), repeating-linear-gradient(90deg, #D4A017 0px, #D4A017 1px, transparent 1px, transparent 40px)' }}
        />
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <p className="text-[#D4A017] uppercase tracking-[0.3em] text-sm font-semibold mb-4" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Expertise Souveraine
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Conseil Institutionnel
          </h1>
          <div className="flex justify-center mb-6">
            <div className="h-[3px] w-20 bg-[#D4A017] rounded-full" />
          </div>
          <p className="text-xl md:text-2xl text-white/80 leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Nous structurons et pilotons vos projets d&apos;État de bout en bout
          </p>
        </div>
      </section>

      {/* Section 1 — Pour qui — White */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-0" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Pour qui ?
          </h2>
          <GoldAccent />
          <p className="text-lg md:text-xl text-[#1B2A4A]/75 leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Ministères, agences nationales, collectivités locales et bailleurs internationaux (AFD, Banque Mondiale, BAD) en Afrique.
          </p>
          <div className="grid md:grid-cols-4 gap-6 mt-14">
            {[
              { icon: 'ri-government-line', label: 'Ministères' },
              { icon: 'ri-building-2-line', label: 'Agences nationales' },
              { icon: 'ri-community-line', label: 'Collectivités locales' },
              { icon: 'ri-global-line', label: 'Bailleurs internationaux' },
            ].map(({ icon, label }) => (
              <div key={label} className="flex flex-col items-center gap-3 p-6 border border-[#1B2A4A]/10 rounded-lg hover:border-[#D4A017] transition-colors">
                <div className="w-12 h-12 flex items-center justify-center text-[#D4A017]">
                  <i className={`${icon} text-3xl`} />
                </div>
                <span className="text-sm font-semibold text-[#1B2A4A] text-center" style={{ fontFamily: 'Montserrat, sans-serif' }}>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gold divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4A017] to-transparent" />

      {/* Section 2 — Ce que nous faisons — Navy */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#1B2A4A]">
        <div className="max-w-5xl mx-auto">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-0" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Ce que nous faisons
            </h2>
            <GoldAccent />
          </div>
          <div className="grid md:grid-cols-2 gap-6 mt-4">
            {[
              { icon: 'ri-database-2-line', text: 'Digitalisation de registres nationaux' },
              { icon: 'ri-shield-keyhole-line', text: 'Gouvernance et systèmes souverains' },
              { icon: 'ri-settings-4-line', text: 'Gestion de projets EPC+F / BOT' },
              { icon: 'ri-cloud-line', text: 'Cloud souverain et protection des données' },
            ].map(({ icon, text }, index) => (
              <div key={index} className="flex items-start gap-5 bg-white/5 border border-white/10 p-6 rounded-lg hover:border-[#D4A017]/50 transition-colors">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#D4A017]/15 rounded-md">
                  <i className={`${icon} text-xl text-[#D4A017]`} />
                </div>
                <p className="text-base md:text-lg text-white/85 leading-relaxed pt-1" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                  {text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gold divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4A017] to-transparent" />

      {/* Section 3 — Notre approche — White */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-0" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Notre approche en 3 phases
            </h2>
            <GoldAccent />
            <p className="text-lg text-[#1B2A4A]/70 leading-relaxed max-w-2xl mx-auto" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Nous intervenons en trois phases : diagnostic stratégique, conception technique, déploiement et transfert de compétences.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mt-14 relative">
            {/* Connector line */}
            <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-px bg-[#D4A017]/30" style={{ left: '16.67%', right: '16.67%' }} />
            {[
              { num: '01', label: 'Diagnostic stratégique', desc: 'Analyse approfondie du contexte institutionnel, des besoins et des contraintes réglementaires.' },
              { num: '02', label: 'Conception technique', desc: 'Architecture souveraine, spécifications fonctionnelles et validation avec les parties prenantes.' },
              { num: '03', label: 'Déploiement & transfert', desc: 'Mise en production, formation des équipes et accompagnement au changement.' },
            ].map(({ num, label, desc }) => (
              <div key={num} className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-[#1B2A4A] border-2 border-[#D4A017] rounded-full flex items-center justify-center mb-5 relative z-10">
                  <span className="text-lg font-bold text-[#D4A017]" style={{ fontFamily: 'Montserrat, sans-serif' }}>{num}</span>
                </div>
                <h3 className="text-lg font-bold text-[#1B2A4A] mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>{label}</h3>
                <p className="text-sm text-[#1B2A4A]/65 leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gold divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4A017] to-transparent" />

      {/* Section 4 — Nos Réalisations — Navy */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#1B2A4A]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-0" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Nos Réalisations
            </h2>
            <GoldAccent />
            <p className="text-lg text-white/65" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Solutions conçues et développées par notre équipe
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-14">
            {[
              {
                tag: 'Transport & Mobilité',
                title: 'Registre National des Transports',
                desc: 'Système de gestion des professionnels du transport avec cartes professionnelles sécurisées, dashboard administratif et architecture offline-first optimisée pour les zones à faible connectivité.',
                techs: ['Flutter', 'Next.js', 'PostgreSQL'],
              },
              {
                tag: 'Gouvernance Publique',
                title: 'Portail E-Gouvernement',
                desc: 'Plateforme d\'intégration multi-ministérielle avec contrôle d\'accès par rôles, portail services citoyens et workflows inter-ministériels.',
                techs: ['Next.js', 'Supabase', 'Cloud souverain'],
              },
              {
                tag: 'Finances Publiques',
                title: 'Tableau de Bord Budgétaire',
                desc: 'Analytics temps réel pour la gestion des finances publiques avec reporting de conformité et accès multi-niveaux. Hébergement souverain.',
                techs: ['React', 'Big Data', 'AI'],
              },
            ].map(({ tag, title, desc, techs }) => (
              <div key={title} className="bg-white/5 border border-white/10 rounded-lg p-8 flex flex-col hover:border-[#D4A017]/50 transition-colors">
                <span className="inline-block border border-[#D4A017]/50 text-[#D4A017] text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full mb-5 self-start whitespace-nowrap">
                  {tag}
                </span>
                <h3 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {title}
                </h3>
                <p className="text-white/65 leading-relaxed text-sm flex-1 mb-6" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                  {desc}
                </p>
                <div className="flex flex-wrap gap-2 mt-auto">
                  {techs.map((tech) => (
                    <span key={tech} className="bg-white/10 text-white/80 text-xs font-medium px-3 py-1 rounded-full border border-white/15 whitespace-nowrap">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/contact"
              className="inline-block bg-[#D4A017] text-white px-10 py-4 rounded-md text-lg font-semibold hover:bg-[#B8860B] transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Discuter de votre projet institutionnel
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default InstitutionalPage;
